import { Box, Typography, useTheme } from "@mui/material";

import { LABEL_WIDTH, ROW_HEIGHT } from "../constants/timelineConstants";

export default function TimelineRowLabel({ label, width = LABEL_WIDTH }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width,
        minHeight: ROW_HEIGHT,
        height: ROW_HEIGHT,
        flexShrink: 0,

        position: "sticky",
        left: 0,
        zIndex: 2,

        bgcolor: theme.palette.background.paper,

        display: "flex",
        alignItems: "center",

        pr: 1,
      }}
    >
      <Typography variant="body2" fontWeight={600} noWrap>
        {label}
      </Typography>
    </Box>
  );
}
